export function initTextTruncation() {
  const textTruncationElements = document.querySelectorAll('[data-text-truncation]');
  if (!textTruncationElements.length) return;

  textTruncationElements.forEach((element) => {
    const characterLimit = Number(element.dataset.textTruncationLimit || 300);
    const fullHtml = element.innerHTML;
    const fullText = element.textContent.trim();

    if (fullText.length <= characterLimit) {
      return;
    }

    const collapsedText = `${fullText.slice(0, characterLimit).trim()}...`;
    const moreLabel = element.dataset.textTruncationMore || 'Mehr anzeigen';
    const lessLabel = element.dataset.textTruncationLess || 'Weniger anzeigen';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'text-truncation__button';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = moreLabel;

    let isExpanded = false;

    const render = () => {
      if (isExpanded) {
        element.innerHTML = fullHtml;
        button.textContent = lessLabel;
        button.setAttribute('aria-expanded', 'true');
      } else {
        element.innerHTML = '';
        const paragraph = document.createElement('p');
        paragraph.textContent = collapsedText;
        element.appendChild(paragraph);
        button.textContent = moreLabel;
        button.setAttribute('aria-expanded', 'false');
      }
    };

    button.addEventListener('click', () => {
      isExpanded = !isExpanded;
      render();
    });

    render();
    element.insertAdjacentElement('afterend', button);
  });
}
